import BaseModel from "~/models/BaseModel";

export default class ImageGalleryModel extends BaseModel {}
